import Vue from 'vue'
import App from './App.vue'
// 变量名只能用router
import router from "./router/index"
//jq
import jquery from "jquery"
Vue.config.productionTip = false
Vue.prototype.$ = jquery

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')